import { HttpParams } from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  Inject,
  inject,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { IconSize } from '@config/defaultValues.constant';
import { FEATURE_FLAGS } from '@config/feature-flags.constant';
import { MsGuestsService } from '@upr-web-primer/ms-guests';
import { NotificationService } from '@upr-web-primer/notification';
import { LocalStorageService } from '@upr-web-primer/storage';
import { UdxSpinnerService } from '@upr-web-primer/udx-spinner';
import { map } from '@upr-web-primer/udx-utils';
import { WINDOW } from '@upr-web-primer/window';
import { DateTime } from 'luxon';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { CommonUtilityService } from '../../services/common-utility.service';

@Component({
  selector: 'app-buy-tickets',
  templateUrl: './buy-tickets.component.html',
  styleUrls: ['./buy-tickets.component.scss'],
  standalone: false,
})
export class BuyTicketsComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  /** Expose feature flag constants to the template */
  readonly FEATURE_FLAGS = FEATURE_FLAGS;

  pageLabels: Record<string, string>;
  tickets = false;
  couponData: any;
  data: any;
  isOpened = false;
  displayProductCardCount: any;
  offerType: any;
  showDiningReservationLink: any;
  showHotelReservationContent: any;
  showBuyTicketsLink: any;
  showLinkTicketsLink: any;
  showTicketContent: boolean;
  showCouponDetails: boolean;
  showHotelReservation: any;
  showSavedTrips: any;
  showDateFormat: any;
  fromDashboard = true;
  languageCode: string;
  previousRoute: string;
  showTicketDetailsCta: boolean;
  isResort: boolean = false;
  eventTargeturl: any;
  @ViewChild('purchaseHistoryEleRef') purchaseHistoryEleRef!: ElementRef;
  cfarEnabled = environment?.cfarEnabled;
  selfServiceEnabled = environment?.selfServiceEnabled;
  deleteAbNormalCard = false;
  cartId = '';

  constructor(
    private readonly title: Title,
    private readonly common: CommonUtilityService,
    private readonly guestsService: MsGuestsService,
    @Inject('AppRoutes') public appRoutes: any,
    @Inject('AppDefaults') public appDefault: any,
    @Inject('GlobalDefaults') public globalDefault: any,
    @Inject('Ranges') public ranges: any,
    public notification: NotificationService,
    private readonly localStorage: LocalStorageService,
    @Inject(WINDOW) private readonly window: any,
    private readonly cookieService: CookieService,
    private readonly renderer: Renderer2,
    @Inject('TriggerDDLMappings') public triggerDDLMappings: any,
    private readonly spinner: UdxSpinnerService,
    private readonly cdr: ChangeDetectorRef,
  ) {
    this.pageLabels = this.common.getResolvedPageData();
    this.title.setTitle(this.pageLabels?.['page.dashboard']);
  }

  /**
   * ngOnInit - call commerceAuthentication() and showCoupons() to get coupons from commerce API
   * displayProductCardCount - Should display no of coupon cards
   */
  ngOnInit(): void {
    this.common?.previousUrl$
      ?.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((previousUrl) => {
        this.previousRoute = previousUrl ? previousUrl : '';
      });
    this.offerType = this.globalDefault.DASHBOARD;

    this.showDiningReservationLink =
      environment.config?.dashboard?.showDiningReservationLink;
    this.showHotelReservationContent =
      environment.config?.dashboard?.showHotelReservationContent;
    this.showBuyTicketsLink = environment.config?.dashboard?.showBuyTicketsLink;
    this.showLinkTicketsLink =
      environment.config?.dashboard?.showLinkTicketsLink;
    this.showHotelReservation =
      environment.config?.dashboard?.showHotelReservation;
    this.showSavedTrips = environment.config?.dashboard?.showSavedTrips;
    this.showDateFormat = environment.config?.dashboard?.showDateFormat;
    this.showTicketContent = environment.config?.dashboard?.showTicketContent;
    this.showTicketDetailsCta =
      environment.config?.dashboard?.showTicketDetailsCta;
    this.isResort = environment.config?.dashboard?.showVacationPackages;
    const authToken = this.localStorage.getItem('loginAuthToken');
    if (authToken) {
      this.showCoupons();
      this.displayProductCardCount = this.ranges.PASSWORDS.INDEX[2];
    } else {
      this.common
        .getResponseObservable()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((data: any) => {
          if (data) {
            this.showCoupons();
            this.displayProductCardCount = this.ranges.PASSWORDS.INDEX[2];
          }
        });
    }
    this.common.triggerDDLEventHandler(
      this.window?.digitalData?.page?.pageInfo?.pageName,
      {
        isPageLoad: true,
      },
    );

    if (this.cfarEnabled || this.selfServiceEnabled) {
      this.common
        .checkForAbnormalCart()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((cartInfo) => {
          this.deleteAbNormalCard = cartInfo.shouldDelete;
          this.cartId = cartInfo.cartId;
        });
    }
  }

  ngAfterViewInit(): void {
    if (this.previousRoute.endsWith('link-tickets')) {
      const getLinkContainer = this.renderer?.selectRootElement(
        '#getLinkContainer',
        true,
      );
      getLinkContainer?.focus();
    }
  }
  addHistoryRoute(): void {
    if (sessionStorage.getItem('purchaseHistory')) {
      const element = this.purchaseHistoryEleRef?.nativeElement;
      if (element) {
        element?.focus();
        element?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'center',
        });
      }
      sessionStorage.removeItem('purchaseHistory');
    }
  }
  /**
   * getLink - On basis of type navigate to respective route
   * @param type
   */
  getLink(type: any): any {
    switch (type) {
      case this.globalDefault.PROFILE:
        this.common.changeRoute(this.appRoutes.MY_PROFILE);
        this.eventTargeturl = this.common.getTargetUrl(
          this.appRoutes.MY_PROFILE,
        );
        this.ddlEvents(
          this.pageLabels?.['dashboard.accountInformation'],
          this.globalDefault.PROFILE,
          this.eventTargeturl,
        );
        break;
      case this.globalDefault.LINK_COUPONS:
        this.common.changeRoute(this.appRoutes.COUPONS, {
          account: this.globalDefault.ACCOUNT,
        });
        this.eventTargeturl = this.common.getTargetUrl(this.appRoutes.COUPONS);
        this.ddlEvents(
          this.pageLabels?.['coupons.couponCardTitle'],
          this.globalDefault.LINK_COUPONS,
          this.eventTargeturl,
        );
        break;
      case this.globalDefault.ORDER:
        this.common.changeRoute(this.appRoutes.ORDER_LIST);
        this.eventTargeturl = this.common.getTargetUrl(
          this.appRoutes.ORDER_LIST,
        );
        this.ddlEvents(
          this.pageLabels?.['dashboard.purchaseHistory'],
          this.globalDefault.ORDER,
          this.eventTargeturl,
        );
        break;
      case this.globalDefault.LINK_TICKETS:
        this.common.setLinkRoute(this.appRoutes.DASHBOARD);
        this.common.changeRoute(this.appRoutes.LINK_TICKETS);
        this.eventTargeturl = this.common.getTargetUrl(
          this.appRoutes.LINK_TICKETS,
        );
        this.ddlEvents(
          this.pageLabels?.['viewEntEmpty.linkTicketsCTA'],
          this.globalDefault.LINK_TICKETS,
          this.eventTargeturl,
        );
        break;
      case this.globalDefault.SAVED_TRIPS:
        this.common.setLinkRoute(this.appRoutes.DASHBOARD);
        this.common.changeRoute(this.appRoutes.SAVED_TRIPS);
        this.eventTargeturl = this.common.getTargetUrl(
          this.appRoutes.SAVED_TRIPS,
        );
        this.ddlEvents(
          this.pageLabels?.['savedTrips.heading'],
          this.globalDefault.SAVED_TRIPS,
          this.eventTargeturl,
        );
        break;
      case this.globalDefault.RESERVATION: {
        this.window.open(environment?.DINING_RESERVATION);
        const url = environment?.DINING_RESERVATION;
        this.eventTargeturl = url;
        this.ddlEvents(
          this.pageLabels?.['dashboard.diningreservation'],
          this.globalDefault.RESERVATION,
          this.eventTargeturl,
        );
        break;
      }
      case this.globalDefault.FAVORITES:
        this.common.changeRoute(this.appRoutes.FAVORITES, { filters: ';' });
        this.common.triggerDDLEventHandler('Favorites', {
          isButtonClick: true,
        });
        break;
    }
  }

  /**
   * showCoupons - Call commerce API to get coupon list for logged in user
   */
  showCoupons(): any {
    this.spinner.show();
    const guestId =
      this.guestsService.helper.getGuestId() ||
      this.localStorage.getItem('LOGGEDIN_GUEST_ID');

    this.common
      ?.getCoupons(guestId)
      ?.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (data: any) => {
          this.spinner.hide();
          this.data = [];
          const coupons = data.couponCodes;
          const todayDate = DateTime.now();

          coupons.map((a: any) => {
            const dateValue = DateTime.fromISO(a.couponExpirationDate, {
              setZone: true,
            });

            if (
              dateValue >= todayDate &&
              (a.status === this.globalDefault.DISTRIBUTED ||
                a.status === this.globalDefault.REFUNDED)
            ) {
              this.data.push(a);
            }
          });
          this.fetchCouponData();
        },
        (errors: any) => {
          this.fetchCouponData();
          if (errors?.status == this.globalDefault.ERROR_401) {
            this.common?.ddlAndLogout();
          } else if (errors?.status == this.globalDefault?.ERROR_503) {
            this.notification.show(this.pageLabels?.['errCode.COMM.503']);
            this.common.eventDDlTrigger(this.pageLabels?.['errCode.COMM.503']);
          } else if (errors?.error) {
            const errCode = 'errCode.' + errors.error?.errorCode;
            const errorCode = errors.error?.errorCode
              ? this.pageLabels?.[errCode]
                ? this.pageLabels?.[errCode]
                : this.pageLabels?.['errCode.E018']
              : errors.error?.errors[0]?.message;

            this.notification?.show(errorCode);
            this.common.eventDDlTrigger(errorCode);
          }
          this.spinner.hide();
        },
      );
  }

  /**
   * fetchCouponData -coupon data sorting and processinf from tridion
   */
  fetchCouponData(): void {
    const couponData = this.data
      ?.sort((a: any, b: any): any => {
        return (
          new Date(a.couponExpirationDate).valueOf() -
          new Date(b.couponExpirationDate).valueOf()
        );
      })
      .slice(this.ranges.PASSWORDS.INDEX[0], this.ranges.PASSWORDS.INDEX[2]);

    map(couponData, (a: any) => {
      const couponIdentifier = a.couponGroupId ? a.couponGroupId : a.couponId; // Determine whether to use couponGroupId or couponId

      this.common
        ?.fetchTridionContents(couponIdentifier)
        ?.pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(
          (data: any) => {
            a.attractionBody = data?.[0]?.['data']?.attractionBody
              ?.replace(
                '{{couponStartDate}}',
                a.couponValidStartDate
                  ? this.getDate(
                      a.couponValidStartDate?.replace('T00:00:00', ''),
                      true,
                    )
                  : '',
              )
              ?.replace(
                '{{couponExpirationDate}}',
                a.couponExpirationDate
                  ? this.getDate(
                      a.couponExpirationDate?.replace('T00:00:00', ''),
                      true,
                    )
                  : '',
              );
            a.heading = data?.[0]?.['data']?.heading;
            a.contentId = data?.[0]?.['data']?.contentId;
            a.description = data?.[0]?.['data']?.description;
            a.attractionHeadline = data?.[0]?.['data']?.attractionHeadline;
            a.categoryLabel = data?.[0]?.['data']?.awning?.[0]?.categoryLabel;
          },
          (errors: any) => {
            if (errors?.status == this.globalDefault.ERROR_401) {
              this.common.setUser();
              localStorage.clear();
              sessionStorage.clear();
              this.cookieService.deleteAll('/', environment.cookieSubDomain);
              const redirectUrl = this.common.getOidcRedirectionUrl();
              this.common.redirectToOidcAppEndSession(redirectUrl);
              this.cdr.markForCheck();
            }
          },
        );
    });
    this.couponData = couponData;
    this.tickets = this.couponData?.length > 0 ? true : false;
    this.cdr.markForCheck();

    this.addHistoryRoute();
  }

  /**
   * redirectToWTS - Navigate back to WTS account
   */
  redirectToWTS(): void {
    this.common.deleteAbnormalCartAndExecute(
      this.deleteAbNormalCard,
      this.cartId,
      () => this.navigateToStore(),
    );
  }

  navigateToStore(): void {
    this.common.clearAllCookies(false, false, false, false);
    this.common.deleteSelfServiceCookies();
    const redirectUrl = this.common.onClickRedirectWTS('', '', true, false);
    this.common.invokeFireEvent(
      this.pageLabels?.['dashboard.buyTickets'],
      'Button',
      'Click',
      null,
      new Date().toISOString(),
      this.pageLabels?.['dashboard.buyTickets'],
      redirectUrl,
      this.window?.digitalData?.page?.category?.primaryCategory ?? '',
      this.window?.digitalData?.page?.category?.subCategory1 ?? '',
    );
  }

  /**
   * openPopup - Open Popup
   */
  openPopup(): void {
    this.isOpened = true;
  }

  /**
   * closePopup - Close Popup
   */
  closePopup(): void {
    this.isOpened = false;
  }

  /**
   * getDate - It will format the date based on locale
   */
  getDate(date: any, weekday?: boolean): string {
    return this.showDateFormat
      ? this.common.getFormattedDateOnLocale(date, false, true)
      : this.common.getFormattedDateOnLocale(date, weekday);
  }
  /**
   * redirecting to the WTS page when we right click and open with new tabs and windows.
   */
  getBuyTicketsLink(): any {
    const USJWTSLoginAuthConfig = this.common.getUSJWTSLoginAuthConfig();
    const url =
      environment.wtsHostBaseUrl +
      `spa_redirect?${new HttpParams({
        fromObject: USJWTSLoginAuthConfig,
      })}`;
    return url;
  }

  /**
   * ddlEvents - On travel party save and update these events are getting set
   * @param type - On api response success or failed
   */
  ddlEvents(label: string, type: any, url: any): void {
    this.common.invokeFireEvent(
      label,
      'Button',
      'Click',
      null,
      new Date().toISOString(),
      type,
      url,
      this.window?.digitalData?.page?.category?.primaryCategory ?? '',
      this.window?.digitalData?.page?.category?.subCategory1 ?? '',
    );
  }

  get favoritesCardConfig(): any {
    return {
      feature: {
        heading: this.pageLabels?.['com.udx.ddev.favorites.my_favorites'],
        svg: {
          iconName:
            this.pageLabels?.['com.udx.ddev.favorites.my_favorites.icon'],
          width: IconSize.MEDIUM,
          height: IconSize.MEDIUM,
        },
      },
      navigationIcon: 'arrow-right',
      iconSize: IconSize.MEDIUM,
      navigate: () => this.getLink('favorites'),
    };
  }
}
